<template>
  <div class="medium-8 row">
    <div class="medium-12 columns">
      <label :class="{ error: validator.origin.$error }">
        {{ $t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.LABEL') }}
        <select
          :value="origin"
          :placeholder="$t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.PLACEHOLDER')"
          @input="$emit('update:origin', $event.target.value)"
        >
          <option
            v-for="opt in storageOrigins"
            :key="opt.value"
            :value="opt.value"
          >
            {{ $t(opt.labelKey) }}
          </option>
        </select>
        <span v-if="validator.origin.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.STORAGE_ORIGIN.ERROR') }}
        </span>
      </label>
    </div>

    <div v-if="currentOriginUsesBucket" class="medium-12 columns">
      <label :class="{ error: validator.custom_config.bucket.$error }">
        {{ $t(`INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.PROVIDERS.${providerKey}.BUCKET.NAME`) }}
        <input
          v-model.trim="config.bucket"
          type="text"
          :placeholder="$t(`INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.PROVIDERS.${providerKey}.BUCKET.PLACEHOLDER`)"
        />
        <span v-if="validator.custom_config.bucket.$error" class="message">
          {{ $t(`INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.PROVIDERS.${providerKey}.BUCKET.ERROR`) }}
        </span>
      </label>
    </div>

    <div class="medium-12 columns">
      <label>
        {{ $t(`INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.PROVIDERS.${providerKey}.PREFIX.NAME`) }}
        <input
          v-model.trim="config.prefix"
          type="text"
          :placeholder="$t(`INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.PROVIDERS.${providerKey}.PREFIX.PLACEHOLDER`)"
        />
      </label>
    </div>

    <template v-if="currentOriginConfig && currentOriginConfig.type === 'file'">
      <div class="medium-12 columns">
        <label :class="{ error: validator.custom_config.credentials.$error }">
          {{ $t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.CREDENTIALS_FILE.LABEL') }}
          <input
            type="file"
            accept="application/json,.json"
            @change="onCredentialsFileChange"
          />
          <p v-if="config.credentials_filename" class="help-text">
            {{ $t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.CREDENTIALS_FILE.LOADED') }}:
            {{ config.credentials_filename }}
          </p>
          <span
            v-if="validator.custom_config.credentials.$error"
            class="message"
          >
            {{ $t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.CREDENTIALS_FILE.ERROR') }}
          </span>
        </label>
      </div>
    </template>

    <template v-if="currentOriginConfig && currentOriginConfig.type === 'fields'">
      <div
        v-for="field in currentOriginConfig.fields"
        :key="field.key"
        class="medium-12 columns"
      >
        <label :class="{ error: validator.custom_config[field.key] && validator.custom_config[field.key].$error }">
          {{ $t(field.labelKey) }}
          <input
            v-model.trim="config[field.key]"
            :type="field.inputType"
            :placeholder="$t(field.placeholderKey)"
            autocomplete="off"
          />
          <span
            v-if="validator.custom_config[field.key] && validator.custom_config[field.key].$error"
            class="message"
          >
            {{ $t(field.errorKey) }}
          </span>
        </label>
      </div>
    </template>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { STORAGE_ORIGINS, ORIGIN_CREDENTIAL_CONFIGS } from 'shared/mixins/multimediaMixin';

export default {
  name: 'MultimediaOriginConfig',
  mixins: [alertMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
    origin: {
      type: String,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    providerKey: {
      type: String,
      default: 'MULTIMEDIA',
    },
  },
  data() {
    return {
      storageOrigins: STORAGE_ORIGINS,
    };
  },
  computed: {
    currentOriginConfig() {
      return ORIGIN_CREDENTIAL_CONFIGS[this.origin] || null;
    },
    currentOriginUsesBucket() {
      return this.currentOriginConfig?.usesBucket !== false;
    },
  },
  methods: {
    onCredentialsFileChange(event) {
      const file = event?.target?.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const parsed = JSON.parse(reader.result);
          this.config.credentials = parsed;
          this.config.credentials_filename = file.name;
        } catch (e) {
          this.config.credentials = null;
          this.config.credentials_filename = file.name;
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.CREDENTIALS_FILE.INVALID_JSON')
          );
        }
      };
      reader.onerror = () => {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.MULTIMEDIA_CHANNEL.CREDENTIALS_FILE.READ_ERROR')
        );
      };
      reader.readAsText(file);
    },
  },
};
</script>
